export type StartupScreenState = 'loading' | 'offline' | 'startupError' | 'unavailable'

const STARTUP_SCREEN_ID = 'startup-screen'
const STARTUP_MESSAGE_ID = 'startup-message'
const STARTUP_RETRY_ID = 'startup-retry'

const stateMessages: Record<StartupScreenState, string> = {
  loading: 'The application is loading...',
  offline: 'You appear to be offline. Check your connection and try again.',
  startupError: 'The application could not start. Please reload the page.',
  unavailable: 'The application is currently unavailable.',
}

function getStartupElements() {
  return {
    startupScreen: document.getElementById(STARTUP_SCREEN_ID),
    startupMessage: document.getElementById(STARTUP_MESSAGE_ID),
    retryButton: document.getElementById(STARTUP_RETRY_ID) as HTMLButtonElement | null,
  }
}

export function setStartupScreenState(state: StartupScreenState) {
  const { startupScreen, startupMessage, retryButton } = getStartupElements()
  if (!startupScreen || !startupMessage || !retryButton) {
    return
  }

  startupScreen.dataset.state = state
  startupMessage.textContent = stateMessages[state]
  retryButton.style.display = state === 'loading' ? 'none' : 'inline-block'
}

export function setStartupRetryHandler(handler: () => void) {
  const { retryButton } = getStartupElements()
  if (!retryButton) {
    return
  }

  retryButton.onclick = handler
}

export function hideStartupScreen() {
  const { startupScreen } = getStartupElements()
  if (!startupScreen) {
    return
  }

  startupScreen.setAttribute('aria-hidden', 'true')
}
